// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-condensed-horizontal-spacing {
  padding-left: 16px;
  padding-right: 16px;
}

.bolt-default-horizontal-spacing {
  padding-left: 20px;
  padding-right: 20px;
}

.bolt-relaxed-horizontal-spacing {
  padding-left: 32px;
  padding-right: 32px;
}

/*# sourceMappingURL=Surface.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/Surface/Surface.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/bin/Components/Surface/Surface.css"],"names":[],"mappings":"AACA;EACI,kBC+TS;ED9TT,mBC8TS;AC9Tb;;AFGA;EACI,kBC8TS;ED7TT,mBC6TS;AC7Tb;;AFGA;EACI,kBCgUS;ED/TT,mBC+TS;AC/Tb;;AAEA,sCAAsC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
